import React, { useContext, useCallback, useMemo } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { EntityUtil } from '@xengage/gw-portals-util-js';
import { withRouter } from 'react-router-dom';
import styles from '../../../SpaAndWellCommonStyles.module.scss';
import metadata from './Massage.metadata.json5';
import MassageTherapists from '../MassageTherapists/MassageTherapists';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function Massage(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('Massage');
    const modelVM = _.get(submissionVM, pathUpdated)
    const viewModelService = useContext(ViewModelServiceContext);
    
    modelVM.value.isValidationReq = true;

    const addmassageTherapists = useCallback(async () => {

        const masRiskObj = {
            tempID: EntityUtil.nextId()
        };

        const { _xCenter, _dtoName } = submissionVM.lobData.spaAndWellLine.coverables.beauticiansSpa.massage.pswmasRisk;

        const masRiskVM = viewModelService.create(masRiskObj, _xCenter, _dtoName);

        submissionVM.lobData.spaAndWellLine.coverables.beauticiansSpa.massage.pswmasRisk.value = submissionVM.lobData.spaAndWellLine.coverables.beauticiansSpa.massage.pswmasRisk.value || []


        submissionVM.lobData.spaAndWellLine.coverables.beauticiansSpa.massage.pswmasRisk.pushElement(
            masRiskVM
        );
        updateWizardData(submissionVM);
    },
        [submissionVM, viewModelService, updateWizardData]
    );

    const massageTherapistOverrides = useMemo(() => {
        const pswmasRisk = _.get(submissionVM, 'lobData.spaAndWellLine.coverables.beauticiansSpa.massage.pswmasRisk', []);
        let overrides = '';

        if (!_.isEmpty(pswmasRisk)) {
            overrides = pswmasRisk?.children.map((masRisk, index) => ({
                [`massageTherapistComponent${index}`]: {
                    overrideProps: {
                        "@field": {
                            // apply to all fields
                            showRequired: true,
                            labelPosition: "left",
                        },
                    },
                    submissionVM,
                    updateWizardData,
                    pathUpdated: `lobData.spaAndWellLine.coverables.beauticiansSpa.massage.pswmasRisk.children[${index}]`,
                    masRiskVM: masRisk,
                    index,
                    viewModelService
                }
            }));
        }

        return Object.assign({}, ...overrides);
    }, [updateWizardData, submissionVM]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },

        ...massageTherapistOverrides,
    };




    const resolvers = {
        resolveCallbackMap: {
            onValidate,
            addmassageTherapists
        },
        resolveComponentMap: {
            massageTherapistComponent: MassageTherapists
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

Massage.propTypes = wizardProps;
export default withRouter(Massage);
